import { projectSettingsServicedeskProactiveServiceManagementRoute } from '@jira/router-routes__project-settings-service-desk-proactive-service-management-routes/src/projectSettingsServicedeskProactiveServiceManagementRoute.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskProactiveServiceManagementAppEntryPoint } from '@jira/spa-apps__project-settings-service-desk-proactive-service-management/src/projectSettingsServicedeskProactiveServiceManagement.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';

const projectSettingsServicedeskProactiveServiceManagementPageEntry = createPageEntryPoint({
	main: projectSettingsServicedeskProactiveServiceManagementAppEntryPoint,
});

export const projectSettingsServicedeskProactiveServiceManagementRouteEntry: Route = createEntry(
	projectSettingsServicedeskProactiveServiceManagementRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'project-settings-servicedesk.proactive-service-management',
		perfMetricKey: 'project-settings-servicedesk.proactive-service-management',

		entryPoint: () => {
			return fg('jsm_psm_visible')
				? projectSettingsServicedeskProactiveServiceManagementPageEntry
				: notFoundPageEntrypoint;
		},

		navigation: {
			menuId: 'PROJECTS',
			sidebarId: 'PROJECT_SETTINGS',
		},

		resources: [
			...getServiceDeskSettingsResources().map((resource) =>
				resourceWithCondition(() => fg('jsm_psm_visible'), resource),
			),
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
